"use client";

import { c as _c } from "react/compiler-runtime";
import { Avatar, Button, Chip, chipVariants, cn, Link, Modal } from "@heroui/react";
import { format, formatDistance } from "date-fns";
import { de, enUS, hu } from "date-fns/locale";
import { BuildingIcon, CalendarRangeIcon, GlobeIcon } from "lucide-react";
import Image from "next/image";
import { useMemo } from "react";
import { DATE_FORMAT } from "@/lib/constants";
import { EXPERIENCES } from "@/lib/experiences";
import { useCurrentLocale, useScopedI18n } from "@/lib/i18n";
import { toDomain } from "@/lib/utils";
const dateFnsLocales = {
  en: enUS,
  de: de,
  hu: hu
};
function capitalize(str: string) {
  if (!str) return "";
  return str[0].toUpperCase() + str.slice(1);
}
export function Experiences(t0) {
  const $ = _c(9);
  const {
    className
  } = t0;
  const t = useScopedI18n("landing.experiences");
  const currentLocale = useCurrentLocale();
  const activeLocale = dateFnsLocales[currentLocale as keyof typeof dateFnsLocales] || enUS;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeLocale || $[3] !== currentLocale || $[4] !== t) {
    t2 = EXPERIENCES.map(experience => {
      const startDate = new Date(experience.startDate);
      const endDate = experience.endDate ? new Date(experience.endDate) : new Date();
      const formattedStart = capitalize(format(startDate, DATE_FORMAT, {
        locale: activeLocale
      }));
      const formattedEnd = experience.endDate ? capitalize(format(endDate, DATE_FORMAT, {
        locale: activeLocale
      })) : "Present";
      const distance = formatDistance(startDate, endDate, {
        locale: activeLocale
      });
      return <Modal key={experience.name}><Button className="group flex h-fit items-center justify-start gap-4 p-4 text-left" variant="ghost" fullWidth={true}>{experience.image ? <Image className="size-14 rounded-large border" src={experience.image} alt={experience.name} width={100} height={100} draggable={false} /> : <Avatar className="size-14 rounded-large border"><Avatar.Fallback>{experience.name[0].toUpperCase()}</Avatar.Fallback></Avatar>}<div><p className="font-medium text-base">{experience.name}</p><p className="text-muted text-sm">{formattedStart}{" - "}{formattedEnd}</p></div></Button><Modal.Backdrop><Modal.Container size="lg"><Modal.Dialog><Modal.CloseTrigger /><Modal.Header><Modal.Heading>{experience.name}</Modal.Heading></Modal.Header><Modal.Body className=""><div className="mb-4 space-x-2"><Chip color="accent" variant="primary"><BuildingIcon className="mr-0.5 size-3.5" />{experience.entity}</Chip><Chip color="default" variant="secondary"><CalendarRangeIcon className="mr-0.5 size-3.5" />{distance} {t("total")}</Chip><Link className={cn(chipVariants({
                    color: "default",
                    variant: "secondary"
                  }).base(), "no-underline")} href={experience.entityUrl} target="_blank"><GlobeIcon className="mr-0.5 size-3.5" />{toDomain(experience.entityUrl)}<Link.Icon /></Link></div><div className="typography [&_*:last-child]:mb-0 [&_*:nth-child(2)]:mt-0 [&_a]:text-base [&_a]:text-default-foreground [&_a]:decoration-[1.5px] [&_a]:decoration-separator-tertiary [&_a]:hover:decoration-muted">{experience.image && <Image className="float-left my-0! mr-3! size-26 rounded-large border" src={experience.image} alt="" width={100} height={100} draggable={false} />}{experience.description[currentLocale as keyof typeof experience.description] || t("noDescription")}</div></Modal.Body><Modal.Footer><Button slot="close">Close</Button></Modal.Footer></Modal.Dialog></Modal.Container></Modal.Backdrop></Modal>;
    });
    $[2] = activeLocale;
    $[3] = currentLocale;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}